<script setup lang="ts">
import { Direction } from '@enums/direction.ts';
import Tooltip from '@components/Tooltip.vue';
</script>

<template>
  <Tooltip
    :direction="Direction.RIGHT"
    panel-class="menu-tooltip__panel"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>

    <template #panel>
      <div class="menu-tooltip__panel-wrapper rounded-lg bg-white p-2">
        <slot name="panel" />
      </div>
    </template>
  </Tooltip>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins/rem' as *;

:deep(.menu-tooltip__panel) {
  @apply top-1/2 -translate-y-1/2 shadow-none border-none bg-transparent pl-4 py-0;
}

.menu-tooltip__panel-wrapper {
  border: 1px solid $colorGray;
  box-shadow: 0 toRem(4) toRem(8) 0 rgb(0 0 0 / 0.25);
}
</style>
